import { injectIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Typography, Button, Grid2 as Grid, Box, Card, CardHeader, CardContent, Stack } from "@mui/material";
import { ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon } from "@mui/icons-material";
import { BACK, FOOTER_COLORI_TRIAGE } from "../../../modules/language";
import { getCodiciColore, fetchCodiciColoreEnded } from "../../../modules/prontoSoccorso";
import { getMessageString } from "../../../utility";
import { LoadingSpinner } from "../../shared/LoadingSpinner";
import { Icona } from "../../shared";

export const CodiciColore = injectIntl(({ intl }) => {
  const navigate = useNavigate();
  const colori = useSelector(getCodiciColore);
  const fetchEnded = useSelector(fetchCodiciColoreEnded);

  return (
    <Box className="codiciColore">
      <Button startIcon={<ArrowBackIosNewOutlinedIcon />} onClick={() => navigate(-1)}>
        {getMessageString(intl, BACK)}
      </Button>
      <Stack className="pageTitle">
        <Icona tipologia="lista" />
        <Typography variant="h2">{getMessageString(intl, FOOTER_COLORI_TRIAGE)}</Typography>
      </Stack>
      <Grid container spacing={4} className="colori">
        {colori?.map((colore, index) => (
          <Grid size={{ xs: 12, md: 6 }} key={index}>
            <Card>
              <CardHeader
                avatar={
                  <Stack
                    sx={{
                      width: "30px",
                      height: "30px",
                      bgcolor: colore.color,
                      ...(colore.id === "bianco" || (colore.id === "white" && { border: "1px solid black" })),
                    }}
                  />
                }
                title={colore.title}
                subheader={colore.subtitle}
              />
              <CardContent>
                {Array.isArray(colore.description) ? (
                  colore.description.map((desc, indexDesc) => <Typography key={indexDesc}>{desc}</Typography>)
                ) : (
                  <Typography>{colore.description}</Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <LoadingSpinner loading={!fetchEnded} />
    </Box>
  );
});
